import React, { useState } from 'react';
import { useAuth } from '../../contexts/SupabaseAuthContext';

// Placeholder logo and icons
const propellerLogoDataUri = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23ef4444'/%3E%3Cpath d='M50 30 L65 50 L50 70 L35 50 Z' fill='white'/%3E%3C/svg%3E";
const Google = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);
const Apple = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
  </svg>
);

const LoginComponent = () => {
    const { signIn, signInWithOAuth, loading } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleEmailLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await signIn(email, password);
        } catch (error) {
            console.error('Login failed:', error);
        }
    }

    return (
        <div className="fixed inset-0 bg-gray-900 flex justify-center items-center p-4 animate-fade-in">
            <div className="bg-gray-800 rounded-xl border border-gray-700 shadow-2xl w-full max-w-sm text-center p-8">
                <div className="mb-6 flex justify-center">
                    <img src={propellerLogoDataUri} alt="HoverAI Logo" className="w-16 h-16"/>
                </div>
                <h1 className="text-3xl font-bold text-white mb-2">Welcome to HoverAI</h1>
                <p className="text-slate-400 mb-8">Your personal flight simulator for life.</p>
                
                <div className="space-y-3">
                    <button
                        onClick={() => signInWithOAuth('google')}
                        disabled={loading}
                        className="w-full px-4 py-3 bg-white text-gray-700 font-bold rounded-lg transition-all duration-300 hover:bg-gray-200 flex items-center justify-center gap-3 mx-auto disabled:opacity-50"
                    >
                        <Google className="w-5 h-5" />
                        Continue with Google
                    </button>
                    <button
                        onClick={() => signInWithOAuth('github')}
                        disabled={loading}
                        className="w-full px-4 py-3 bg-black text-white font-bold rounded-lg transition-all duration-300 hover:bg-gray-900 flex items-center justify-center gap-3 mx-auto disabled:opacity-50"
                    >
                        <Apple className="w-5 h-5" />
                        Continue with GitHub
                    </button>
                </div>

                <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-600" />
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="bg-gray-800 px-2 text-gray-400">OR</span>
                    </div>
                </div>

                <form onSubmit={handleEmailLogin} className="space-y-4">
                    <input 
                        type="email" 
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-slate-200 focus:ring-2 focus:ring-red-500 focus:outline-none transition"
                        required
                    />
                    <input 
                        type="password" 
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-slate-200 focus:ring-2 focus:ring-red-500 focus:outline-none transition"
                        required
                    />
                     <button
                        type="submit"
                        disabled={loading}
                        className="w-full px-6 py-3 bg-red-600 text-white font-bold rounded-lg transition-all duration-300 hover:bg-red-700 disabled:opacity-50"
                    >
                        {loading ? (
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mx-auto"></div>
                        ) : (
                            'Sign In with Email'
                        )}
                    </button>
                </form>

            </div>
        </div>
    );
};

export default LoginComponent;